import React, {useCallback, useEffect, useState} from "react";
import useEmblaCarousel from "embla-carousel-react";
import classNames from "classnames";
import useViewItemBatcher from "@/Hooks/useViewItemBatcher";
import CatalogCard from "@/Components/Site/CatalogCard";
import Svg from "@/Components/Svg";
import "@/Scss/Site/Product/related.scss";

const Related = (props) => {
    const {product = {}} = props;
    const {productsRelated = []} = product;
    const [scrollSnaps, setScrollSnaps] = useState([]);
    const [selectedSnap, setSelectedSnap] = useState(0);

    const [carouselRef, emblaApi] = useEmblaCarousel(
        {loop: productsRelated.length > 1, align: 'start'}
    );

    const scrollTo = useCallback((index) => {
        emblaApi?.scrollTo(index);
    }, [emblaApi]);

    useEffect(() => {
        if (!emblaApi) return;

        const onReInit = (api) => {
            setScrollSnaps(api.scrollSnapList());
            setSelectedSnap(api.selectedScrollSnap());
        };

        const onSelect = (api) => {
            setSelectedSnap(api.selectedScrollSnap());
        };

        onReInit(emblaApi);

        emblaApi.on('reInit', onReInit);
        emblaApi.on('select', onSelect);

        return () => {
            emblaApi.off('reInit', onReInit);
            emblaApi.off('select', onSelect);
        };
    }, [emblaApi]);

    const goToPrev = useCallback(() => {
        emblaApi?.scrollPrev();
    }, [emblaApi]);

    const goToNext = useCallback(() => {
        emblaApi?.scrollNext();
    }, [emblaApi]);

    const {registerView} = useViewItemBatcher();

    if (productsRelated.length === 0) return null;

    return (
        <div className={`related`}>
            <p className={`related__title`}>Покупают вместе</p>
            <div className={`related__body embla`}>
                <div ref={carouselRef} className={`embla__viewport`}>
                    <div className={`embla__container`}>
                        {productsRelated.map((product, i) => {
                            return <CatalogCard
                                key={product.id}
                                el={product}
                                {...props}
                                index={i + 1}
                                registerView={registerView}
                                className={`embla__slide`}
                            />
                        })}
                    </div>
                </div>
                {scrollSnaps.length > 1 && (
                    <div className={`embla__controls`}>
                        <div className={`embla__dots`}>
                            {scrollSnaps.map((_, index) => (
                                <div
                                    key={`dot-${index}`}
                                    className={classNames('embla__dot', {
                                        'embla__dot--selected': index === selectedSnap,
                                    })}
                                    onClick={() => scrollTo(index)}
                                >
                                </div>
                            ))}
                        </div>
                        <div className={`embla__buttons`}>
                            <div className={`embla__prev`} onClick={goToPrev}>
                                <Svg id={`arrowLeft`} className={`svg--arrow`} />
                            </div>
                            <div className={`embla__next`} onClick={goToNext}>
                                <Svg id={`arrowRight`} className={`svg--arrow`} />
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Related;
